import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { AuthUtility } from '../../../../core/utility/auth-utility';
import { PersonaService } from '../../../../services/persona/persona.service';
import { ChildStudentInfo } from '../../../../core/models/persona/persona.model';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-dashboard-padre',
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatIconModule,
    ],
    templateUrl: './dashboard-padre.html',
})
export class DashboardPadre implements OnInit {

    loading: boolean = false;
    childrenList: ChildStudentInfo[] = [];

    constructor(
        private personaService: PersonaService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadChildren();
    }

    private loadChildren(): void {
        const payload = AuthUtility.getValidTokenPayload();
        const personId = payload?.person_id || payload?.personId;

        if (!personId) return;

        setTimeout(() => {
            this.loading = true;
            this.personaService.getChildrens(personId).subscribe({
                next: (res: any) => {
                    this.loading = false;
                    if (res.success === 1 && res.data) {
                        this.childrenList = res.data;
                    } else if (res.success === 0) {
                        const msg = res.errors?.length > 0 ? res.errors[0].message : res.message;
                        this.toastr.warning(msg || 'No se pudo cargar la información de sus estudiantes.', 'Advertencia');
                    }
                    this.cdr.detectChanges();
                },
                error: (err: any) => {
                    this.loading = false;
                    const msg = err.error?.errors?.[0]?.message || err.error?.message || 'Error al conectar con el servidor';
                    this.toastr.error(msg, 'Error');
                    this.cdr.detectChanges();
                }
            });
        });
    }
}
